var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Oidc from 'oidc-client';
import { SentrySettingsClient } from "../generated";
var LogLevels = /** @class */ (function () {
    function LogLevels() {
    }
    LogLevels.NONE = Oidc.Log.NONE;
    LogLevels.ERROR = Oidc.Log.ERROR;
    LogLevels.WARN = Oidc.Log.WARN;
    LogLevels.INFO = Oidc.Log.INFO;
    LogLevels.DEBUG = Oidc.Log.DEBUG;
    return LogLevels;
}());
export { LogLevels };
var loc = window.location;
var host = loc.protocol + "//" + loc.host;
var mgr;
var loggedInUser;
var clientId = "";
var readyCallback;
function reloadApplication(origin) {
    var url = location.protocol + '//' + location.host + location.pathname;
    console.log(origin + ", reloading app (" + url + ")");
    loggedInUser = null;
    location.replace(url);
}
function getUrlVar(key) {
    var result = new RegExp(key + "=([^&]*)", "i").exec(window.location.search);
    return result && result[1] || "";
}
export function getUser() {
    return loggedInUser;
}
export function getUsername() {
    if (!loggedInUser || !loggedInUser.profile || !loggedInUser.profile.name)
        return "";
    return loggedInUser.profile.name;
}
export function getDisplayname() {
    if (!loggedInUser || !loggedInUser.profile)
        return "";
    var givenName = loggedInUser.profile.given_name;
    var familyName = loggedInUser.profile.family_name;
    if (givenName !== null || familyName !== null) {
        if (!givenName)
            return familyName;
        else if (!familyName)
            return givenName;
        else
            return givenName + " " + familyName;
    }
    return getUsername();
}
export function getUserTenant() {
    if (!loggedInUser || !loggedInUser.profile || !loggedInUser.profile.tenant)
        return "";
    return loggedInUser.profile.tenant;
}
export function userHasRole(roles, anyRole) {
    if (anyRole === void 0) { anyRole = true; }
    if (!loggedInUser || !loggedInUser.profile || !loggedInUser.profile.role)
        return false;
    //If there is only one role it is passed as a string make it an array
    //otherwise a check on a substring will be done.
    if (typeof loggedInUser.profile.role === "string")
        loggedInUser.profile.role = [loggedInUser.profile.role];
    if (anyRole) {
        return roles.some(function (role) {
            return loggedInUser.profile.role.indexOf(role) !== -1;
        });
    }
    else {
        return roles.every(function (role) {
            return loggedInUser.profile.role.indexOf(role) !== -1;
        });
    }
}
export function userGetRoles() {
    if (!loggedInUser || !loggedInUser.profile || !loggedInUser.profile.role)
        return [];
    return loggedInUser.profile.role;
}
export function userLogout() {
    document.cookie = "token_" + clientId + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    mgr.signoutRedirect();
}
function storePath() {
    var queryIndex = loc.href.indexOf('?');
    var query = queryIndex > -1 ? loc.href.slice(queryIndex) : "";
    window.localStorage.setItem("query", query);
    window.localStorage.setItem("hash", loc.hash);
    window.localStorage.setItem("path", loc.pathname);
}
function applyStoredPath() {
    var storedQuery = window.localStorage.getItem("query");
    var storedHash = window.localStorage.getItem("hash");
    var storedPath = window.localStorage.getItem("path");
    var path = host + storedPath;
    if (storedQuery) {
        path += storedQuery;
    }
    else if (storedHash) {
        path += storedHash;
    }
    window.history.pushState({ path: path }, '', path);
}
function initUserManager(settings) {
    var token = getUrlVar("token");
    var tokenAcr = "";
    if (token != null && token != "")
        tokenAcr = "token:" + token;
    mgr = new Oidc.UserManager({
        authority: settings.uri,
        client_id: settings.clientId,
        includeIdTokenInSilentRenew: false,
        redirect_uri: host + settings.redirectUri,
        post_logout_redirect_uri: host + settings.postLogoutUri,
        // these two will be done dynamically from the buttons clicked, but are
        // needed if you want to use the silent_renew
        response_type: "id_token token",
        scope: settings.requestedScopes ? settings.requestedScopes.join(" ") : "",
        // silent renew will get a new access_token via an iframe
        // just prior to the old access_token expiring (60 seconds prior)
        silent_redirect_uri: host + settings.silentRenewUri,
        automaticSilentRenew: true,
        // will raise events for when user has performed a logout at IdentityServer
        monitorSession: true,
        // this will allow all the OIDC protocol claims to vbe visible in the window. normally a client app
        // wouldn't care about them or want them taking up space
        filterProtocolClaims: true,
        // this will use the user info endpoint if it's an OIDC request and there's an access_token
        loadUserInfo: true,
        acr_values: tokenAcr
    });
    mgr.events.addUserUnloaded(function () { return reloadApplication("User Unloaded"); });
    mgr.events.addUserSignedOut(function () { return reloadApplication("User Signed Out"); });
    mgr.events.addAccessTokenExpired(function () { return reloadApplication("Access Token Expired"); });
    mgr.events.addSilentRenewError(function (error) { return reloadApplication("Silent Renew Error: " + error); });
    mgr.events.addUserLoaded(function (u) {
        document.cookie = "token_" + clientId + "=" + u.access_token + "; path=/; max-age=" + u.expires_in;
        loggedInUser = u;
    });
}
export function start(callback, settings, logLevel) {
    if (logLevel === void 0) { logLevel = LogLevels.WARN; }
    return __awaiter(this, void 0, void 0, function () {
        var sentrySettingsClient;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Oidc.Log.logger = console;
                    Oidc.Log.level = logLevel;
                    if (!settings) return [3 /*break*/, 1];
                    console.warn("Passing settings to the sentry client is obsolete apps should use the SentrySettingsClient!");
                    return [3 /*break*/, 3];
                case 1:
                    sentrySettingsClient = new SentrySettingsClient();
                    return [4 /*yield*/, sentrySettingsClient.get()];
                case 2:
                    settings = _a.sent();
                    _a.label = 3;
                case 3:
                    clientId = settings.clientId;
                    readyCallback = callback;
                    initUserManager(settings);
                    // checks to see if the page being loaded looks like a login callback
                    if (loc.hash.indexOf("#id_token") === -1) {
                        storePath();
                        mgr.clearStaleState().then(function () {
                            mgr.signinRedirect({
                                scope: settings.requestedScopes ? settings.requestedScopes.join(" ") : "",
                                response_type: "id_token token"
                            });
                        });
                    }
                    else {
                        mgr.signinRedirectCallback().then(function (user) {
                            applyStoredPath();
                            loggedInUser = user;
                            //loggedin user
                            if (readyCallback)
                                readyCallback(user);
                            else
                                console.error("readyCallback null");
                        }, function (error) {
                            console.error(error);
                            mgr.signinRedirect({
                                scope: settings.requestedScopes ? settings.requestedScopes.join(" ") : "",
                                response_type: "id_token token"
                            });
                        });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=sentryClient.js.map